import { useSelector } from 'react-redux'

import NumberFormat from 'react-number-format'
import { Dialog, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useBuy } from '../../hooks/useBuy'
// import { Link } from 'react-router-dom'

export const InvoceModalList = ({ title, openModal, setModal, dataCompra, setForm, checkInitialData }) => {

    const { listaTiposDocumentos } = useSelector(state => state.general)
    const { initUpdateBuy } = useBuy()

    const facturasList = [
        {
            id: dataCompra.id,
            numero: dataCompra.nro_doc_justificacion || '',
            documento: (listaTiposDocumentos.find(it => parseInt(it.id) === parseInt(dataCompra.id_tipo_documento)))?.nombre || '',
            proveedor: dataCompra.razon_social || '',
            total: dataCompra.total_compra,
            separacion_miles: dataCompra.separacion_miles,
            separacion_decimales: dataCompra.separacion_decimales,
            simbolo: dataCompra.simbolo,
            url_doc_justificacion: dataCompra.url_doc_justificacion
        }
    ]

    const handleUpdateBuyDoc = async () => {

        const newDataUpdated = {
            ...dataCompra,
            nro_doc_justificacion: '',
            url_doc_justificacion: ''
        }

        setForm(newDataUpdated)
        await initUpdateBuy(newDataUpdated)
        await checkInitialData(dataCompra.id)

        setModal(false)
    }

    return (
        <Dialog
            className='dialogModalList'
            open={openModal}
            onClose={() => setModal(false)}
            aria-labelledby="simple-dialog-title"
        >
            <div className='ContainerDialogs'>
                <h1 className='title-lista-pagos'>
                    {title}
                    <IconButton
                        style={{ padding: '0', float: 'right' }}
                        aria-label="close"
                        onClick={() => setModal(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </h1>

                <div className="table-responsive">
                    <table className="table p-table-global lista-pagos">
                        <thead className='p-thead-global'>
                            <tr className="text-center p-tr-titles-global">
                                <th scope="col">Número</th>
                                <th scope="col">Documento</th>
                                <th scope="col">Proveedor</th>
                                <th scope="col">Total</th>
                                <th scope="col">Link</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {facturasList.map(item => (
                                <tr className="text-center p-tr-body-global" key={item.id}>
                                    <td>{item.numero}</td>
                                    <td>{item.documento}</td>
                                    <td>{item.proveedor}</td>
                                    <td>
                                        <NumberFormat
                                            value={item.total}
                                            displayType={'text'}
                                            thousandSeparator={item.separacion_miles}
                                            decimalSeparator={item.separacion_decimales}
                                            prefix={`${item.simbolo} `}
                                        />
                                    </td>
                                    <td>
                                        {(item?.url_doc_justificacion !== null && item?.url_doc_justificacion !== '') ?
                                            <a
                                                className='p-links'
                                                href={item?.url_doc_justificacion || ''}
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Ver documento
                                            </a>
                                            :
                                            <span style={{ textTransform: 'none' }}>---</span>
                                        }
                                    </td>
                                    <td>
                                        <i
                                            className="bi bi-trash ms-3"
                                            style={{ cursor: 'pointer' }}
                                            onClick={handleUpdateBuyDoc}
                                        ></i>
                                    </td>
                                </tr>
                            ))
                            }
                        </tbody>
                    </table>
                </div>

            </div>
        </Dialog>
    )
}
